export default __webpack_public_path__ + "static/media/print.826647b0.jpg";